<template>
  <transition>
    <div v-show="drawer" class="Drawerroot">
      <div>
      <div class="top-title">
        <span>配置</span>
        <span style="cursor:pointer" @click="drawer = false">
          <i class="el-icon-circle-close"></i>
        </span>
      </div>
      <div class="main">
          <el-tabs style="margin-left: 20px;" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-if="type == 'picture' || type == 'line'" label="颜色配置" name="1">
            <!-- 颜色配置 -->
            <div style="display: flex;justify-content: center;text-align: center;flex-direction: column;">
              <div class="title">编辑信息</div>
              <div class="box" v-if="type == 'picture'">
                <span>背景颜色</span>
                <input type="color" name="bgColor" @input="color($event,1)" ref="bacolor" id="bgColor">
              </div>
              <div class="box">
                <span>边框颜色</span>
                <input type="color" name="bgColor" @input="color($event,2)" ref="bacolor" id="bgColor">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="type != 'picture' && type != 'line'" label="设备绑定" name="2">
            <!-- <install ref="install"></install> -->
          </el-tab-pane>
        </el-tabs>
        <div class="footer">
          <el-button type="primary" @click="oper(1)" round>确定</el-button>
          <el-button round @click="oper(2)" v-if="type == 'picture' || type == 'line'">恢复默认</el-button>
          <el-button type="danger" @click="oper(3)" round>删除</el-button>
        </div>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
// import install from '@/pages/module-project/common-module/bloack_install_she.vue'

export default {
  components:{
    // install
  },
  data() {
    return {
      drawer:false,
      borderColor:'',
      backColor:'',
      data:'',
      edit:'',
      activeName: '1',
      type:'',
      graph:'',
      
    }
  },
  methods:{
    color(e,index){
      if(index == 1){
          this.edit.attr('body/fill',e.target.value)
      }else if(index == 2){
        if(this.edit.store.data.type == 'picture'){
          this.edit.attr('body/stroke',e.target.value)
        }else{
          this.edit.setData({
            borderColor:e.target.value
          })
        }
      }
    },
    setDrawer(drawer,edit,graph){
      console.log("打开",edit);
      this.drawer = drawer;
      this.type = edit.store.data.type;
      this.activeName = this.type == 'picture' || this.type == 'line'?'1':'2'
      this.edit = edit;
      this.graph = graph;
      if(this.type == undefined){
        this.$bus.$emit('install-init','');
        this.$bus.$emit('install-getList','');
      }
    },
    handleClick(tab, event) {
        },
    oper(index){
      switch(index){
        case 1:
          if(this.type == undefined){
            this.$message.success("该功能后续开发中 请敬请期待~~~")
            // let obj = {};
            // this.$bus.$emit('install-add',obj);
            // console.log("obj",obj);
            console.log("设备绑定")
          }else
          this.drawer = false;
        break;
        case 2:
        this.edit.attr('body/fill','rgba(0,0,0,0.0001)')
          if(this.edit.store.data.type == 'picture'){
            this.edit.attr('body/stroke','rgb(151, 151, 151)')
          }else{
            console.log("测试",this.edit.getData())
            this.edit.setData({
              borderColor:'rgb(151, 151, 151)'
            })
          }
          // this.drawer = false;
        break;
        case 3:
          this.$alert('确定删除节点嘛', '删除', {
            confirmButtonText: '确定',
            callback: action => {
              // let cell = this.graph.getSelectedCells()
              // this.graph.cut(cell);

              console.log('删除节点',this.edit.children)
              if(!!!this.edit.children || this.edit.children.length == 0){
                this.graph.removeNode(this.edit)
                this.drawer = false;
              }else{
                this.$message.warning('区域里面还有数据 无法直接删除')
              }
              return;

              this.graph.removeNode(this.edit)
              this.drawer = false;
            }
          });
        break;
      }
    }
  },
}
</script>

<style scoped>
  .Drawerroot{
    position: absolute;
    z-index: 99;
    right: 0px;
    width: 30%;
    /* border: 1px solid black; */
    box-shadow: 8px 1px 13px 9px rgba(0,0,0,0.7);
    height: 100%;
    background-color: #fff;
  }
  .v-enter-active{
    animation: scale-up-hor-right 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }
  .v-leave-active{
    animation: scale-down-hor-right 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  /* 抽屉打开动画 */
  @keyframes scale-up-hor-right {
    0% {
      -webkit-transform: scaleX(0.4);
              transform: scaleX(0.4);
      -webkit-transform-origin: 100% 100%;
              transform-origin: 100% 100%;
    }
    100% {
      -webkit-transform: scaleX(1);
              transform: scaleX(1);
      -webkit-transform-origin: 100% 100%;
              transform-origin: 100% 100%;
    }
  }
  /* 抽屉退出动画 */
  @keyframes scale-down-hor-right {
    0% {
      -webkit-transform: scaleX(1);
              transform: scaleX(1);
      -webkit-transform-origin: 100% 100%;
              transform-origin: 100% 100%;
    }
    100% {
      -webkit-transform: scaleX(0.3);
              transform: scaleX(0.3);
      -webkit-transform-origin: 100% 100%;
              transform-origin: 100% 100%;
    }
  }
  .top-title{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    /* background-color: red; */
  }
  .top-title span:nth-child(1){
    color:rgb(148, 151, 155);
    margin-left: 20px;
    font-size: 17px;
  }
  
  .top-title span:nth-child(2){
    margin-right: 20px;
    font-size: 25px;
    color:rgb(148, 151, 155);
  }
  .main{
    height: 100vh;
    width: 100%;
  }
  .box{
    width: 60%;
    margin-left: 20%;
    margin-top: 20%;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .footer{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom:5%;
  }
  .title{
    /* font-weight: ; */
    margin-top: 10%;
    font-size: 30px;
  }
</style>